import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  // Badge,
  Nav,
  Tab,
  Button,
  Spinner,
} from "react-bootstrap";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaClipboardList,
  FaExclamationTriangle,
  FaChartPie,
  FaShieldAlt, // ضفنا أيقونة الدرع هنا للتربية العسكرية
  // FaCheck,
  // FaTimes,
  // FaCalendarAlt,
} from "react-icons/fa";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
// import Swal from 'sweetalert2';
import "../../assets/styles/AdminDashboard.css";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// تسجيل مكونات Chart.js
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
);

const AdminDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState("activities");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/users/admin-dashboard");
        const AdminData = res?.data;
        const AdminData1 = {
          role: AdminData.role,
          stats: AdminData.stats,
          activityStatusStats: AdminData.activityStatusStats,
          categoryStats: AdminData.categoryStats,
          topStudents: AdminData.topStudents,
          pendingActivityApprovals: AdminData.pendingActivityApprovals,
          pendingProfileRequests: AdminData.pendingProfileRequests,
          pendingRoleChangeReqs: AdminData.pendingRoleChangeReqs,
        };
        setData(AdminData1);
      } catch (err) {
        console.error("Error loading dashboard:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // --- Advanced PDF Report Generation ---
  const handleGenerateReport = () => {
    if (!data) return;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Colors Configuration
    const primaryColor = [67, 97, 238]; // #4361ee
    const secondaryColor = [63, 55, 201]; // #3f37c9
    const grayColor = [245, 247, 255]; // Light Gray

    // --- 1. Header Section ---
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 25, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text("CampusPulse Admin Summary", 14, 16);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const today = new Date().toLocaleString();
    doc.text(`Generated on: ${today}`, 14, 22);

    // --- 2. System Overview (Global Stats) ---
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("1. System Overview", 14, 35);

    autoTable(doc, {
      startY: 40,
      head: [["Metric", "Value", "Metric", "Value"]],
      body: [
        [
          "Total Users",
          data.stats.totalUsers,
          "Total Supervisors",
          data.stats.totalSupervisors,
        ],
        [
          "Total Students",
          data.stats.totalStudents,
          "Total Activities",
          data.stats.totalActivities,
        ],
        [
          "Avg Attendance",
          data.stats.systemAttendanceRate,
          // "Pending Requests",
          // data.stats.pendingActivityCount +
          //   data.stats.pendingProfileCount +
          //   (data.stats.pendingPromotCount || 0),
        ],
      ],
      theme: "grid",
      headStyles: {
        fillColor: secondaryColor,
        textColor: 255,
        fontStyle: "bold",
      },
      columnStyles: {
        0: { fontStyle: "bold", fillColor: grayColor, width: 40 },
        2: { fontStyle: "bold", fillColor: grayColor, width: 40 },
      },
    });

    let finalY = doc.lastAutoTable.finalY + 15;

    // --- 3. Activity Health & Status ---
    doc.setFontSize(14);
    doc.text("2. Activity Health & Analytics", 14, finalY);

    const statusData = [
      [
        "Active Activities",
        data.activityStatusStats.active,
        "Ongoing right now",
      ],
      [
        "Finished Activities",
        data.activityStatusStats.finished,
        "Completed successfully",
      ],
      [
        "Pending Approvals",
        data.activityStatusStats.pending,
        "Awaiting admin action",
      ],
      [
        "Cancelled",
        data.activityStatusStats.cancelled,
        "Terminated activities",
      ],
    ];

    autoTable(doc, {
      startY: finalY + 5,
      head: [["Status", "Count", "Description"]],
      body: statusData,
      theme: "striped",
      headStyles: { fillColor: [50, 50, 50] }, // Dark Header
      columnStyles: {
        0: { fontStyle: "bold" },
        1: { fontStyle: "bold", halign: "center", textColor: primaryColor },
      },
    });

    finalY = doc.lastAutoTable.finalY + 10;

    // Check space
    if (finalY > pageHeight - 60) {
      doc.addPage();
      finalY = 20;
    }

    doc.setFontSize(11);
    doc.setTextColor(100);
    doc.text("Category Breakdown:", 14, finalY);

    const categoryData = Object.entries(data?.categoryStats).map(
      ([key, value]) => [key.charAt(0).toUpperCase() + key.slice(1), value],
    );

    autoTable(doc, {
      startY: finalY + 5,
      head: [["Category", "Total Activities"]],
      body: categoryData,
      theme: "grid",
      tableWidth: "wrap",
      headStyles: { fillColor: [108, 117, 125] },
    });

    // --- 5. Top Students Leaderboard ---
    finalY = doc.lastAutoTable.finalY + 15;

    if (finalY > pageHeight - 50) {
      doc.addPage();
      finalY = 20;
    }

    doc.setFontSize(14);
    doc.setTextColor(40, 40, 40);
    doc.text("3. Top Performing Students", 14, finalY);

    autoTable(doc, {
      startY: finalY + 5,
      head: [["Rank", "Name", "ID / Email", "Points"]],
      body: data.topStudents.map((std, index) => [
        `#${index + 1}`,
        std.name,
        std.email,
        `${std.totalPoints || 0} PTS`,
      ]),
      theme: "striped",
      headStyles: { fillColor: [6, 214, 160] },
    });

    // --- Footer ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, {
        align: "right",
      });
      doc.text(
        `Confidential System Report - Generated by Admin`,
        14,
        pageHeight - 10,
      );
    }

    doc.save(`Admin_Summary_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  // --- Handlers (Action Logic) ---
  const handleActivityAction = (id) => {
    navigate(`/activities/categories/${id}`);
  };

  const handleViewProfile = function (id) {
    navigate(`/admin/view-user-profile/${id}`);
  };
  const handleViewDetails = (id, activeType) => {
    navigate(`/admin/request-details/${id}?type=${activeType}`);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <Spinner
          animation="grow"
          variant="primary"
          style={{ width: "3rem", height: "3rem" }}
        />
      </div>
    );
  }

  // --- Chart Configs ---
  const doughnutData = {
    labels: ["Academic", "Sports", "Entertain", "Compet"],
    datasets: [
      {
        data: Object.values(data?.categoryStats),
        backgroundColor: ["#4361ee", "#06d6a0", "#4cc9f0", "#f72585"],
        borderWidth: 0,
        hoverOffset: 10,
      },
    ],
  };

  const barData = {
    labels: ["Pending", "Active", "Finished", "Cancelled"],
    datasets: [
      {
        label: "Activities",
        data: Object.values(data.activityStatusStats),
        backgroundColor: ["#f72585", "#4cc9f0", "#06d6a0", "#ef476f"],
        borderRadius: 8,
        barThickness: 30,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: { usePointStyle: true, padding: 20 },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { display: true, borderDash: [5, 5] }, beginAtZero: true },
    },
  };

  return (
    <Container fluid className="py-5 px-lg-5 mt-5">
      {/* 1. Header Section */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5 gap-3">
        <div>
          <h2 className="fw-bold mb-1" style={{ color: "#2b2d42" }}>
            Admin Dashboard
          </h2>
          <p className="text-muted mb-0">
            Overview of system performance and pending tasks.
          </p>
        </div>

        {/* =========================================================
            التعديل هنا: حطينا الزرارين جنب بعض بشكل احترافي
            ========================================================= */}
        <div className="d-flex flex-wrap gap-3">
          <Button
            variant="outline-dark" // لون مختلف عشان يبان إنه إدارة نظام
            className="px-4 py-2 rounded-pill shadow-sm fw-bold d-flex align-items-center"
            onClick={() => navigate("/admin/military-management")} // الراوت اللي هنعمله للصفحة
          >
            <FaShieldAlt className="me-2 text-primary" size={18} />
            إدارة التربية العسكرية
          </Button>

          <Button
            variant="primary"
            className="px-4 py-2 rounded-pill shadow-sm fw-bold d-flex align-items-center"
            onClick={handleGenerateReport}
          >
            <FaClipboardList className="me-2" /> Generate Report
          </Button>
        </div>
      </div>

      {/* 2. Stats Cards */}
      <Row className="g-4 mb-5">
        <StatCard
          title="Total Students"
          value={data.stats.totalStudents}
          icon={<FaUserGraduate />}
          color="primary"
        />
        <StatCard
          title="Total Supervisors"
          value={data.stats.totalSupervisors}
          icon={<FaChalkboardTeacher />}
          color="info"
        />
        <StatCard
          title="Engagement Rate"
          value={data.stats.systemAttendanceRate}
          icon={<FaChartPie />}
          color="success"
        />
        <StatCard
          title="Pending Requests"
          value={
            data.stats.pendingActivityCount +
            data.stats.pendingProfileCount +
            data.stats.pendingPromotCount
          }
          icon={<FaExclamationTriangle />}
          color="warning"
          isAlert
        />
      </Row>

      {/* 3. Charts Section */}
      <Row className="mb-5">
        <Col lg={8} className="mb-4 mb-lg-0">
          <Card className="dashboard-card p-3">
            <Card.Body>
              <h5 className="fw-bold mb-4 text-dark">
                Activity Status Analytics
              </h5>
              <div className="chart-container">
                <Bar data={barData} options={chartOptions} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="dashboard-card p-3">
            <Card.Body>
              <h5 className="fw-bold mb-4 text-dark">Activity Categories</h5>
              <div className="chart-container d-flex justify-content-center">
                <Doughnut
                  data={doughnutData}
                  options={{ ...chartOptions, scales: {} }}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* 4. Action Center (The Main Focus) */}
      <Card className="dashboard-card shadow-sm border-0">
        <Card.Header className="bg-white border-0 pt-4 px-4">
          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
              <h5 className="fw-bold text-dark m-0 mb-3 mb-md-0">
                Management Console
              </h5>
              <Nav variant="pills" className="custom-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="activities">
                    Activity Requests
                    {data.stats.pendingActivityCount > 0 && (
                      <span className="notification-badge">
                        {data.stats.pendingActivityCount}
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="upgrade-requests">
                    Upgrade Reqs
                    {data.stats.pendingPromotCount > 0 && (
                      <span className="notification-badge">
                        {data.stats.pendingPromotCount}
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="profiles">
                    Profile Changes
                    {data.stats.pendingProfileCount > 0 && (
                      <span className="notification-badge">
                        {data.stats.pendingProfileCount}
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="top-students">Leaderboard</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Tab.Content className="mt-4">
              {/* === TAB 1: ACTIVITY APPROVALS === */}
              <Tab.Pane eventKey="activities">
                <div className="table-responsive table-custom-container">
                  <Table hover className="custom-table">
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th className="text-end" style={{ minWidth: "120px" }}>
                          Quick Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.pendingActivityApprovals.length > 0 ? (
                        data.pendingActivityApprovals.map((act) => (
                          <tr key={act.id}>
                            <td className="text-info">
                              {act.category.toUpperCase()}
                            </td>
                            <td className="text-end">
                              <button
                                className="btn bg-warning text-light rounded-4"
                                title="Approve"
                                onClick={() => handleActivityAction(act.id)}
                              >
                                check details
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center py-5 text-success"
                          >
                            All caught up! No pending activities.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>

              {/* === TAB 2: PROFILE REQUESTS === */}
              <Tab.Pane eventKey="profiles">
                <div className="table-responsive table-custom-container">
                  <Table hover className="custom-table">
                    <thead>
                      <tr>
                        <th>Req Change</th>
                        <th className="text-end">details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.pendingProfileRequests.length > 0 ? (
                        data.pendingProfileRequests.map((req) => (
                          <tr key={req.id}>
                            <td>
                              <div className="d-flex flex-column">
                                <small
                                  className="text-danger text-decoration-line-through mb-1"
                                  style={{ fontSize: "0.6rem" }}
                                >
                                  {req.oldValue}
                                </small>
                                <span
                                  style={{ fontSize: "0.8rem" }}
                                  className="text-success fw-bold bg-light-success px-2 py-1 rounded d-inline-block"
                                >
                                  {req.newValue}
                                </span>
                              </div>
                            </td>
                            <td className="text-end">
                              <Button
                                variant="outline-success"
                                size="sm"
                                className="me-2 rounded-pill px-3"
                                onClick={() => {
                                  handleViewDetails(req.id, "profile");
                                }}
                              >
                                details
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center py-5 text-muted"
                          >
                            No pending profile requests.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>

              {/* === TAB 3: upgrade-requests === */}
              <Tab.Pane eventKey="upgrade-requests">
                <div className="table-responsive table-custom-container">
                  <Table hover className="custom-table">
                    <thead>
                      <tr>
                        <th>Std id</th>
                        <th className="text-end">details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.pendingRoleChangeReqs.length > 0 ? (
                        data.pendingRoleChangeReqs.map((req) => (
                          <tr key={req.id}>
                            <td>
                              <div className="d-flex flex-column">
                                <small
                                  className="text-danger text-decoration-line-through mb-1"
                                  style={{ fontSize: "0.6rem" }}
                                >
                                  {req.fromRole}
                                </small>
                                <span
                                  style={{ fontSize: "0.8rem" }}
                                  className="text-success fw-bold bg-light-success px-2 py-1 rounded d-inline-block"
                                >
                                  {req.toRole}
                                </span>
                              </div>
                            </td>
                            <td className="text-end">
                              <Button
                                variant="outline-success"
                                size="sm"
                                className="me-2 rounded-pill px-3"
                                onClick={() => {
                                  handleViewDetails(req.id, "roles");
                                }}
                              >
                                details
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center py-5 text-muted"
                          >
                            No pending profile requests.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>

              {/* === TAB 4: TOP STUDENTS === */}
              <Tab.Pane eventKey="top-students">
                <div className="table-responsive table-custom-container">
                  <Table hover className="custom-table">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Student Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.topStudents.map((std, idx) => (
                        <tr
                          key={idx}
                          onClick={() => handleViewProfile(std._id)}
                        >
                          <td>
                            {idx === 0 ? (
                              <span style={{ fontSize: "1.4rem" }}>🥇</span>
                            ) : idx === 1 ? (
                              <span style={{ fontSize: "1.4rem" }}>🥈</span>
                            ) : idx === 2 ? (
                              <span style={{ fontSize: "1.4rem" }}>🥉</span>
                            ) : (
                              <span className="fw-bold text-muted">
                                #{idx + 1}
                              </span>
                            )}
                          </td>
                          <td className="fw-bold text-center">
                            {std.name.split(" ").slice(0, 2).join(" ")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Card.Header>
      </Card>
    </Container>
  );
};

// --- Sub-Component: Stat Card ---
const StatCard = ({ title, value, icon, color, isAlert }) => (
  <Col md={6} xl={3}>
    <Card className="dashboard-card">
      <Card.Body className="d-flex align-items-center justify-content-between p-4">
        <div>
          <div
            className="text-muted text-uppercase fw-bold small mb-2"
            style={{ letterSpacing: "1px" }}
          >
            {title}
          </div>
          <div className="h3 mb-0 fw-bold text-dark">{value}</div>
          {isAlert && (
            <div className="mt-2 text-danger fw-bold small animate__animated animate__pulse animate__infinite">
              Requires Attention
            </div>
          )}
        </div>
        <div className={`card-icon-bg bg-light-${color}`}>{icon}</div>
      </Card.Body>
      <div
        style={{
          height: "4px",
          background: `var(--${color}-color)`,
          width: "100%",
        }}
      ></div>
    </Card>
  </Col>
);

export default AdminDashboard;

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Table,
//   // Badge,
//   Nav,
//   Tab,
//   Button,
//   Spinner,
// } from "react-bootstrap";
// import {
//   FaUserGraduate,
//   FaChalkboardTeacher,
//   FaClipboardList,
//   FaExclamationTriangle,
//   FaChartPie,
//   // FaCheck,
//   // FaTimes,
//   // FaCalendarAlt,
// } from "react-icons/fa";
// import { Doughnut, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
// } from "chart.js";
// // import Swal from 'sweetalert2';
// import "../../assets/styles/AdminDashboard.css";
// import api from "../../services/api";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// // تسجيل مكونات Chart.js
// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
// );

// const AdminDashboard = () => {
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState(null);
//   const [activeTab, setActiveTab] = useState("activities");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await api.get("/users/admin-dashboard");
//         const AdminData = res?.data;
//         const AdminData1 = {
//           role: AdminData.role,
//           stats: AdminData.stats,
//           activityStatusStats: AdminData.activityStatusStats,
//           categoryStats: AdminData.categoryStats,
//           topStudents: AdminData.topStudents,
//           pendingActivityApprovals: AdminData.pendingActivityApprovals,
//           pendingProfileRequests: AdminData.pendingProfileRequests,
//           pendingRoleChangeReqs: AdminData.pendingRoleChangeReqs,
//         };
//         setData(AdminData1);
//       } catch (err) {
//         console.error("Error loading dashboard:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // --- Advanced PDF Report Generation ---
//   const handleGenerateReport = () => {
//     if (!data) return;

//     const doc = new jsPDF();
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     // Colors Configuration
//     const primaryColor = [67, 97, 238]; // #4361ee
//     const secondaryColor = [63, 55, 201]; // #3f37c9
//     const grayColor = [245, 247, 255]; // Light Gray

//     // --- 1. Header Section ---
//     doc.setFillColor(...primaryColor);
//     doc.rect(0, 0, pageWidth, 25, "F");

//     doc.setTextColor(255, 255, 255);
//     doc.setFontSize(20);
//     doc.setFont("helvetica", "bold");
//     doc.text("CampusPulse Admin Summary", 14, 16);

//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     const today = new Date().toLocaleString();
//     doc.text(`Generated on: ${today}`, 14, 22);

//     // --- 2. System Overview (Global Stats) ---
//     doc.setTextColor(40, 40, 40);
//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     doc.text("1. System Overview", 14, 35);

//     autoTable(doc, {
//       startY: 40,
//       head: [["Metric", "Value", "Metric", "Value"]],
//       body: [
//         [
//           "Total Users",
//           data.stats.totalUsers,
//           "Total Supervisors",
//           data.stats.totalSupervisors,
//         ],
//         [
//           "Total Students",
//           data.stats.totalStudents,
//           "Total Activities",
//           data.stats.totalActivities,
//         ],
//         [
//           "Avg Attendance",
//           data.stats.systemAttendanceRate,
//           // "Pending Requests",
//           // data.stats.pendingActivityCount +
//           //   data.stats.pendingProfileCount +
//           //   (data.stats.pendingPromotCount || 0),
//         ],
//       ],
//       theme: "grid",
//       headStyles: {
//         fillColor: secondaryColor,
//         textColor: 255,
//         fontStyle: "bold",
//       },
//       columnStyles: {
//         0: { fontStyle: "bold", fillColor: grayColor, width: 40 },
//         2: { fontStyle: "bold", fillColor: grayColor, width: 40 },
//       },
//     });

//     let finalY = doc.lastAutoTable.finalY + 15;

//     // --- 3. Activity Health & Status (THE NEW PART) ---
//     // ده الجزء اللي بيعوض التفاصيل بأرقام مجمعة
//     doc.setFontSize(14);
//     doc.text("2. Activity Health & Analytics", 14, finalY);

//     // هنجهز الداتا للجدول
//     const statusData = [
//       [
//         "Active Activities",
//         data.activityStatusStats.active,
//         "Ongoing right now",
//       ],
//       [
//         "Finished Activities",
//         data.activityStatusStats.finished,
//         "Completed successfully",
//       ],
//       [
//         "Pending Approvals",
//         data.activityStatusStats.pending,
//         "Awaiting admin action",
//       ],
//       [
//         "Cancelled",
//         data.activityStatusStats.cancelled,
//         "Terminated activities",
//       ],
//     ];

//     autoTable(doc, {
//       startY: finalY + 5,
//       head: [["Status", "Count", "Description"]],
//       body: statusData,
//       theme: "striped",
//       headStyles: { fillColor: [50, 50, 50] }, // Dark Header
//       columnStyles: {
//         0: { fontStyle: "bold" },
//         1: { fontStyle: "bold", halign: "center", textColor: primaryColor }, // تلوين الأرقام بالأزرق
//       },
//     });

//     // --- 4. Categories Distribution (Optional but nice) ---
//     // بنعرض توزيع الأنشطة (رياضي - ثقافي - الخ) جنب الأرقام
//     // عشان نوفر مساحة ممكن نخلي الجدول ده يبدأ بعد اللي قبله علطول

//     finalY = doc.lastAutoTable.finalY + 10;

//     // Check space
//     if (finalY > pageHeight - 60) {
//       doc.addPage();
//       finalY = 20;
//     }

//     doc.setFontSize(11);
//     doc.setTextColor(100);
//     doc.text("Category Breakdown:", 14, finalY);

//     const categoryData = Object.entries(data?.categoryStats).map(
//       ([key, value]) => [
//         key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
//         value,
//       ],
//     );

//     autoTable(doc, {
//       startY: finalY + 5,
//       head: [["Category", "Total Activities"]],
//       body: categoryData,
//       theme: "grid",
//       tableWidth: "wrap", // جدول صغير على قد المحتوى
//       headStyles: { fillColor: [108, 117, 125] },
//     });

//     // --- 5. Top Students Leaderboard ---
//     // ده الجدول الوحيد اللي فيه تفاصيل لأنه مهم جداً ومش هيكبر أوي (دايما Top 5 or 10)
//     finalY = doc.lastAutoTable.finalY + 15;

//     if (finalY > pageHeight - 50) {
//       doc.addPage();
//       finalY = 20;
//     }

//     doc.setFontSize(14);
//     doc.setTextColor(40, 40, 40);
//     doc.text("3. Top Performing Students", 14, finalY);

//     autoTable(doc, {
//       startY: finalY + 5,
//       head: [["Rank", "Name", "ID / Email", "Points"]], // دمجنا ال ID وال Email لتوفير المساحة
//       body: data.topStudents.map((std, index) => [
//         `#${index + 1}`,
//         std.name,
//         std.email, // لو الايميل مش موجود يعرض ال ID
//         `${std.totalPoints || 0} PTS`,
//       ]),
//       theme: "striped",
//       headStyles: { fillColor: [6, 214, 160] }, // Green for Success
//     });

//     // --- Footer ---
//     const pageCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= pageCount; i++) {
//       doc.setPage(i);
//       doc.setFontSize(8);
//       doc.setTextColor(150);
//       doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, {
//         align: "right",
//       });
//       doc.text(
//         `Confidential System Report - Generated by Admin`,
//         14,
//         pageHeight - 10,
//       );
//     }

//     doc.save(`Admin_Summary_${new Date().toISOString().split("T")[0]}.pdf`);
//   };
//   // Fake Data Fetching
//   // useEffect(() => {
//   //   setTimeout(() => {
//   //     const mockData = {
//   //       role: "admin",
//   //       stats: {
//   //         totalStudents: 1250,
//   //         totalSupervisors: 45,
//   //         totalActivities: 120,
//   //         pendingActivityCount: 2,
//   //         pendingProfileCount: 3,
//   //         systemAttendanceRate: "78.5%",
//   //       },
//   //       activityStatusStats: {
//   //         pending: 5,
//   //         active: 12,
//   //         finished: 98,
//   //         cancelled: 5,
//   //       },
//   //       categoryStats: {
//   //         academic: 40,
//   //         sports: 50,
//   //         entertainment: 20,
//   //         competition: 10,
//   //       },
//   //       topStudents: [
//   //         { name: "Ahmed Ali", email: "ahmed@edu.eg", totalPoints: 450 },
//   //         { name: "Sarah Mona", email: "sarah@edu.eg", totalPoints: 410 },
//   //         { name: "Omar Khaled", email: "omar@edu.eg", totalPoints: 380 },
//   //         { name: "Hassan Youssef", email: "hassan@edu.eg", totalPoints: 350 },
//   //       ],
//   //       pendingActivityApprovals: [
//   //         {
//   //           id: 1,
//   //           title: "Intro to AI Workshop",
//   //           date: "Oct 12, 2025",
//   //           category: "academic",
//   //           status: "Needs Approval",
//   //         },
//   //         {
//   //           id: 2,
//   //           title: "University Football League",
//   //           date: "Oct 15, 2025",
//   //           category: "sports",
//   //           status: "Needs Approval",
//   //         },
//   //       ],
//   //       pendingProfileRequests: [
//   //         {
//   //           id: 101,
//   //           studentName: "Mahmoud Hassan",
//   //           universityID: "2021001",
//   //           fieldToChange: "faculty",
//   //           oldValue: "Engineering",
//   //           newValue: "AI & Data",
//   //           reason: "Transfer approved by dean",
//   //         },
//   //         {
//   //           id: 102,
//   //           studentName: "Salma Nader",
//   //           universityID: "2021055",
//   //           fieldToChange: "level",
//   //           oldValue: "Level 3",
//   //           newValue: "Level 4",
//   //           reason: "System error fix",
//   //         },
//   //         {
//   //           id: 103,
//   //           studentName: "Kareem Ezz",
//   //           universityID: "2022099",
//   //           fieldToChange: "universtyID",
//   //           oldValue: "2022099",
//   //           newValue: "2022100",
//   //           reason: "Typo in ID",
//   //         },
//   //       ],
//   //     };
//   //     setData(mockData);
//   //     setLoading(false);
//   //   }, 1500);
//   // }, []);

//   // --- Handlers (Action Logic) ---
//   const handleActivityAction = (id) => {
//     navigate(`/activities/categories/${id}`);
//   };

//   const handleViewProfile = function (id) {
//     navigate(`/admin/view-user-profile/${id}`);
//   };
//   const handleViewDetails = (id, activeType) => {
//     navigate(`/admin/request-details/${id}?type=${activeType}`);
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
//         <Spinner
//           animation="grow"
//           variant="primary"
//           style={{ width: "3rem", height: "3rem" }}
//         />
//       </div>
//     );
//   }

//   // --- Chart Configs ---
//   const doughnutData = {
//     labels: ["Academic", "Sports", "Entertain", "Compet"],
//     datasets: [
//       {
//         data: Object.values(data?.categoryStats),
//         backgroundColor: ["#4361ee", "#06d6a0", "#4cc9f0", "#f72585"],
//         borderWidth: 0,
//         hoverOffset: 10,
//       },
//     ],
//   };

//   const barData = {
//     labels: ["Pending", "Active", "Finished", "Cancelled"],
//     datasets: [
//       {
//         label: "Activities",
//         data: Object.values(data.activityStatusStats),
//         backgroundColor: ["#f72585", "#4cc9f0", "#06d6a0", "#ef476f"],
//         borderRadius: 8,
//         barThickness: 30,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "bottom",
//         labels: { usePointStyle: true, padding: 20 },
//       },
//     },
//     scales: {
//       x: { grid: { display: false } },
//       y: { grid: { display: true, borderDash: [5, 5] }, beginAtZero: true },
//     },
//   };

//   return (
//     <Container fluid className="py-5 px-lg-5 mt-5">
//       {/* 1. Header Section */}
//       <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
//         <div className="mb-3 mb-md-0">
//           <h2 className="fw-bold mb-1" style={{ color: "#2b2d42" }}>
//             Admin Dashboard
//           </h2>
//           <p className="text-muted mb-0">
//             Overview of system performance and pending tasks.
//           </p>
//         </div>
//         <Button
//           variant="primary"
//           className="px-4 py-2 rounded-pill shadow-sm fw-bold"
//           onClick={handleGenerateReport}
//         >
//           <FaClipboardList className="me-2" /> Generate Report
//         </Button>
//       </div>

//       {/* 2. Stats Cards */}
//       <Row className="g-4 mb-5">
//         <StatCard
//           title="Total Students"
//           value={data.stats.totalStudents}
//           icon={<FaUserGraduate />}
//           color="primary"
//         />
//         <StatCard
//           title="Total Supervisors"
//           value={data.stats.totalSupervisors}
//           icon={<FaChalkboardTeacher />}
//           color="info"
//         />
//         <StatCard
//           title="Engagement Rate"
//           value={data.stats.systemAttendanceRate}
//           icon={<FaChartPie />}
//           color="success"
//         />
//         <StatCard
//           title="Pending Requests"
//           value={
//             data.stats.pendingActivityCount +
//             data.stats.pendingProfileCount +
//             data.stats.pendingPromotCount
//           }
//           icon={<FaExclamationTriangle />}
//           color="warning"
//           isAlert
//         />
//       </Row>

//       {/* 3. Charts Section */}
//       <Row className="mb-5">
//         <Col lg={8} className="mb-4 mb-lg-0">
//           <Card className="dashboard-card p-3">
//             <Card.Body>
//               <h5 className="fw-bold mb-4 text-dark">
//                 Activity Status Analytics
//               </h5>
//               <div className="chart-container">
//                 <Bar data={barData} options={chartOptions} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col lg={4}>
//           <Card className="dashboard-card p-3">
//             <Card.Body>
//               <h5 className="fw-bold mb-4 text-dark">Activity Categories</h5>
//               <div className="chart-container d-flex justify-content-center">
//                 <Doughnut
//                   data={doughnutData}
//                   options={{ ...chartOptions, scales: {} }}
//                 />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* 4. Action Center (The Main Focus) */}
//       <Card className="dashboard-card shadow-sm border-0">
//         <Card.Header className="bg-white border-0 pt-4 px-4">
//           <Tab.Container
//             activeKey={activeTab}
//             onSelect={(k) => setActiveTab(k)}
//           >
//             {/* Header Flex Row: Stacks on mobile, Row on Desktop */}
//             <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
//               <h5 className="fw-bold text-dark m-0 mb-3 mb-md-0">
//                 Management Console
//               </h5>
//               {/* Custom Tabs with corrected Badge styling */}
//               <Nav variant="pills" className="custom-tabs">
//                 <Nav.Item>
//                   <Nav.Link eventKey="activities">
//                     Activity Requests
//                     {data.stats.pendingActivityCount > 0 && (
//                       <span className="notification-badge">
//                         {data.stats.pendingActivityCount}
//                       </span>
//                     )}
//                   </Nav.Link>
//                 </Nav.Item>
//                 <Nav.Item>
//                   <Nav.Link eventKey="upgrade-requests">
//                     Upgrade Reqs
//                     {data.stats.pendingPromotCount > 0 && (
//                       <span className="notification-badge">
//                         {data.stats.pendingPromotCount}
//                       </span>
//                     )}
//                   </Nav.Link>
//                 </Nav.Item>
//                 <Nav.Item>
//                   <Nav.Link eventKey="profiles">
//                     Profile Changes
//                     {data.stats.pendingProfileCount > 0 && (
//                       <span className="notification-badge">
//                         {data.stats.pendingProfileCount}
//                       </span>
//                     )}
//                   </Nav.Link>
//                 </Nav.Item>
//                 <Nav.Item>
//                   <Nav.Link eventKey="top-students">Leaderboard</Nav.Link>
//                 </Nav.Item>
//               </Nav>
//             </div>{" "}
//             {/* pendingPromotCount */}
//             <Tab.Content className="mt-4">
//               {/* === TAB 1: ACTIVITY APPROVALS === */}
//               <Tab.Pane eventKey="activities">
//                 <div className="table-responsive table-custom-container">
//                   <Table hover className="custom-table">
//                     <thead>
//                       <tr>
//                         {/* <th>Activity Name</th> */}
//                         <th>Category</th>
//                         {/* <th>Date</th> */}
//                         {/* <th>Current Status</th> */}
//                         <th className="text-end" style={{ minWidth: "120px" }}>
//                           Quick Actions
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {data.pendingActivityApprovals.length > 0 ? (
//                         data.pendingActivityApprovals.map((act) => (
//                           <tr key={act.id}>
//                             <td className="text-info">
//                               {act.category.toUpperCase()}
//                             </td>
//                             <td className="text-end">
//                               <button
//                                 className="btn bg-warning text-light rounded-4"
//                                 title="Approve"
//                                 onClick={() => handleActivityAction(act.id)}
//                               >
//                                 check details
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="5"
//                             className="text-center py-5 text-success"
//                           >
//                             All caught up! No pending activities.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Tab.Pane>

//               {/* === TAB 2: PROFILE REQUESTS === */}
//               <Tab.Pane eventKey="profiles">
//                 <div className="table-responsive table-custom-container">
//                   <Table hover className="custom-table">
//                     <thead>
//                       <tr>
//                         {/* <th>Student Details</th> */}
//                         {/* <th>Field</th> */}
//                         <th>Req Change</th>
//                         {/* <th>Reason</th> */}
//                         <th className="text-end">details</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {data.pendingProfileRequests.length > 0 ? (
//                         data.pendingProfileRequests.map((req) => (
//                           <tr key={req.id}>
//                             {/* <td>
//                               <div className="d-flex align-items-center">
//                                 <div className="avatar-circle me-3">
//                                   {req.studentName.charAt(0)}
//                                 </div>
//                                 <div>
//                                   <div className="fw-bold text-dark">
//                                     {req.studentName}
//                                   </div>
//                                   <small className="text-muted">
//                                     {req.universityID}
//                                   </small>
//                                 </div>
//                               </div>
//                             </td> */}
//                             {/* <td className="text-uppercase fw-bold text-primary small">
//                               {req.fieldToChange}
//                             </td> */}
//                             <td>
//                               <div className="d-flex flex-column">
//                                 <small
//                                   className="text-danger text-decoration-line-through mb-1"
//                                   style={{ fontSize: "0.6rem" }}
//                                 >
//                                   {req.oldValue}
//                                 </small>
//                                 <span
//                                   style={{ fontSize: "0.8rem" }}
//                                   className="text-success fw-bold bg-light-success px-2 py-1 rounded d-inline-block"
//                                 >
//                                   {req.newValue}
//                                 </span>
//                               </div>
//                             </td>
//                             {/* <td>
//                               <small className="text-muted fst-italic">
//                                 "{req.reason}"
//                               </small>
//                             </td> */}
//                             <td className="text-end">
//                               <Button
//                                 variant="outline-success"
//                                 size="sm"
//                                 className="me-2 rounded-pill px-3"
//                                 onClick={() => {
//                                   handleViewDetails(req.id, "profile");
//                                 }}
//                               >
//                                 details
//                               </Button>
//                               {/* <Button
//                                 variant="outline-danger"
//                                 size="sm"
//                                 className="rounded-pill px-3"
//                               >
//                                 Reject
//                               </Button> */}
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="5"
//                             className="text-center py-5 text-muted"
//                           >
//                             No pending profile requests.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Tab.Pane>

//               {/* === TAB 3: upgrade-requests === */}
//               <Tab.Pane eventKey="upgrade-requests">
//                 <div className="table-responsive table-custom-container">
//                   <Table hover className="custom-table">
//                     <thead>
//                       <tr>
//                         <th>Std id</th>
//                         <th className="text-end">details</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {data.pendingRoleChangeReqs.length > 0 ? (
//                         data.pendingRoleChangeReqs.map((req) => (
//                           <tr key={req.id}>
//                             <td>
//                               <div className="d-flex flex-column">
//                                 <small
//                                   className="text-danger text-decoration-line-through mb-1"
//                                   style={{ fontSize: "0.6rem" }}
//                                 >
//                                   {req.fromRole}
//                                 </small>
//                                 <span
//                                   style={{ fontSize: "0.8rem" }}
//                                   className="text-success fw-bold bg-light-success px-2 py-1 rounded d-inline-block"
//                                 >
//                                   {req.toRole}
//                                 </span>
//                               </div>
//                             </td>
//                             <td className="text-end">
//                               <Button
//                                 variant="outline-success"
//                                 size="sm"
//                                 className="me-2 rounded-pill px-3"
//                                 onClick={() => {
//                                   handleViewDetails(req.id, "roles");
//                                 }}
//                               >
//                                 details
//                               </Button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="5"
//                             className="text-center py-5 text-muted"
//                           >
//                             No pending profile requests.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Tab.Pane>

//               {/* === TAB 4: TOP STUDENTS === */}
//               <Tab.Pane eventKey="top-students">
//                 <div className="table-responsive table-custom-container">
//                   <Table hover className="custom-table">
//                     <thead>
//                       <tr>
//                         <th>Rank</th>
//                         <th>Student Name</th>
//                         {/* <th>Contact</th> */}
//                         {/* <th>Total Points</th> */}
//                         {/* <th>Performance Index</th> */}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {data.topStudents.map((std, idx) => (
//                         <tr
//                           key={idx}
//                           onClick={() => handleViewProfile(std._id)}
//                         >
//                           {" "}
//                           {/* ^^ */}
//                           <td>
//                             {idx === 0 ? (
//                               <span style={{ fontSize: "1.4rem" }}>🥇</span>
//                             ) : idx === 1 ? (
//                               <span style={{ fontSize: "1.4rem" }}>🥈</span>
//                             ) : idx === 2 ? (
//                               <span style={{ fontSize: "1.4rem" }}>🥉</span>
//                             ) : (
//                               <span className="fw-bold text-muted">
//                                 #{idx + 1}
//                               </span>
//                             )}
//                           </td>
//                           <td className="fw-bold text-center">
//                             {std.name.split(" ").slice(0, 2).join(" ")}
//                           </td>
//                           {/* <td className="text-muted">{std.email}</td> */}
//                           {/* <td>
//                             <span className="bg-primary text-light rounded-pill px-3 py-2">
//                               {std.totalPoints} PTS
//                             </span>
//                           </td> */}
//                           {/* <td style={{ width: "20%" }}>
//                             <div
//                               className="progress"
//                               style={{
//                                 height: "8px",
//                                 borderRadius: "10px",
//                                 backgroundColor: "#e9ecef",
//                               }}
//                             >
//                               <div
//                                 className="progress-bar"
//                                 role="progressbar"
//                                 style={{
//                                   width: `${(std.totalPoints / 100) * 100}%`,
//                                   background:
//                                     "linear-gradient(90deg, var(--primary-color), var(--info-color))",
//                                 }}
//                               ></div>
//                             </div>
//                           </td> */}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Tab.Pane>
//             </Tab.Content>
//           </Tab.Container>
//         </Card.Header>
//       </Card>
//     </Container>
//   );
// };

// // --- Sub-Component: Stat Card ---
// const StatCard = ({ title, value, icon, color, isAlert }) => (
//   <Col md={6} xl={3}>
//     <Card className="dashboard-card">
//       <Card.Body className="d-flex align-items-center justify-content-between p-4">
//         <div>
//           <div
//             className="text-muted text-uppercase fw-bold small mb-2"
//             style={{ letterSpacing: "1px" }}
//           >
//             {title}
//           </div>
//           <div className="h3 mb-0 fw-bold text-dark">{value}</div>
//           {isAlert && (
//             <div className="mt-2 text-danger fw-bold small animate__animated animate__pulse animate__infinite">
//               Requires Attention
//             </div>
//           )}
//         </div>
//         <div className={`card-icon-bg bg-light-${color}`}>{icon}</div>
//       </Card.Body>
//       <div
//         style={{
//           height: "4px",
//           background: `var(--${color}-color)`,
//           width: "100%",
//         }}
//       ></div>
//     </Card>
//   </Col>
// );

// export default AdminDashboard;
